import type { Person, Relationship } from '../types.ts';
import { buildSosaMap, buildRelIndex } from '../hooks/useTreeLayout.ts';

/**
 * #1710 — Sosa-nummer per persoon, berekend zoals de stamboom het toont
 * (zelfde `buildSosaMap`, vanaf de project-proband; bij kwartierverlies het
 * laagste nummer). Vervangt het lezen van `people.sosa_number`: die kolom werd
 * alleen herberekend bij het zetten van de proband en liep daarna achter.
 */
export function sosaPerPersoon(
  probandId: string | null | undefined,
  people: Person[],
  relationships: Relationship[]
): Map<string, number> {
  if (!probandId) return new Map();
  return buildSosaMap(
    probandId,
    new Map(people.map((p) => [p.id, p])),
    buildRelIndex(relationships)
  );
}
